import { GenericHeader, SearchBar } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import ListComp from 'components/ListComp';
import React from 'react';
import { Mastery } from 'services';
import { Results, CreateModal } from './components';
import { curriculum_manager } from 'utils/constants';
import { Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  button: {
    "&:not(:last-child)": {
      marginRight: theme.spacing(2)
    }
  }
}));

const MasteryList = props => {
  const classes = useStyles();

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Masteries" subheader="Mastery Management" {...rest} >
        <Button className={classes.button} color="primary" as="a" href="/masteries/reorder" variant="contained">
          Reorder
        </Button>
        <Button className={classes.button} color="primary" onClick={handleCreateOpen} variant="contained">
          Add Mastery
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Mastery.list}
      title="Masteries"
      name="masteries"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[curriculum_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default MasteryList;
